import type {
  BoardFilterStickersBoardState,
  BoardFilterStickersSliceState,
} from './boardFilterStickers.types'

export const createEmptyBoardFilterStickersBoardState =
  (): BoardFilterStickersBoardState => ({
    rows: [],
    visibleStickerRows: [],
    allStickerRows: [],
    loading: false,
    error: null,
    isInitialized: false,
  })

export const createInitialBoardFilterStickersState =
  (): BoardFilterStickersSliceState => ({
    byBoardId: {},
    reloadTokens: {},
  })
